import { Vorgang } from '../../types';

export function getReparaturkosten(vorgang: Vorgang) {
  return vorgang?.bewertung?.reparaturkosten ? parseFloat(vorgang?.bewertung?.reparaturkosten) : 0;
}
